<template>
  <div v-if="nieuws.length > 0">
    <!-- ===== FEATURED ===== -->
    <!-- <div class="section featured text-center d-flex flex-column align-center">
      <span class="ws-eyebrow">
        {{ nieuws[0].location + " · " + getDate(nieuws[0].timestamp) }}
      </span>
      <h1 class="ws-h1 mt-4 featured-title">{{ nieuws[0].title }}</h1>
      <p class="ws-lead featured-sub">{{ nieuws[0].subtitle }}</p>
      <div class="featured-cta">
        <button
          class="ws-btn ws-btn--primary"
          @click="$router.push(`/nieuws/${nieuws[0].uid}`)"
        >
          Lees verder →
        </button>
        <button class="ws-btn ws-btn--ghost" @click="scrollToAll">
          Bekijk alle artikelen ↓
        </button>
      </div>
      <div class="ws-media featured-media">
        <v-img
          height="42vh"
          width="100%"
          cover
          :src="nieuws[0].header_image"
        ></v-img>
      </div>
    </div> -->

    <!-- ===== ALL ARTICLES ===== -->
    <div class="section pt-0 mt-10" id="alles">
      <div class="text-center mb-2">
        <span class="ws-eyebrow">Op de hoogte blijven</span>
        <h2 class="ws-h2 mt-3">Ons laatste nieuws</h2>
      </div>
      <div class="news-grid mt-10 ws-stagger" v-reveal>
        <router-link
          class="news-card ws-reveal"
          v-for="(artikel, index) in nieuws"
          :key="index"
          :style="{ '--i': index }"
          :to="`/nieuws/${artikel.uid}`"
        >
          <div class="news-img">
            <v-img
              :src="artikel.header_image"
              :alt="artikel.title"
              aspect-ratio="1.6"
              cover
            ></v-img>
          </div>
          <div class="news-body">
            <span class="news-date">{{ getDate(artikel.timestamp) }}</span>
            <h3>{{ artikel.title }}</h3>
            <p>{{ artikel.subtitle }}</p>
            <span class="ws-link news-link">Lees verder →</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapState } from "vuex";
import { useMeta } from "vue-meta";

export default {
  setup() {
    useMeta({
      title: "Nieuws",
    });
  },
  computed: {
    ...mapState({
      nieuws: (state) => state.nieuws,
    }),
  },
  methods: {
    getDate(d) {
      let i = DateTime.fromSeconds(d);
      return i.toLocaleString(DateTime.DATE_FULL);
    },
    scrollToAll() {
      const el = document.getElementById("alles");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.featured {
  padding-bottom: 6vh;
}
.featured-title {
  max-width: 760px;
}
.featured-sub {
  max-width: 460px;
  margin-top: 18px;
}
.featured-cta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  margin: 30px 0 40px;
}
.featured-media {
  width: 100%;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}
.news-card {
  background: #fff;
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid rgba(42, 32, 24, 0.05);
  box-shadow: 0 14px 40px -26px rgba(60, 36, 21, 0.28);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: transform var(--ws-dur-fast) var(--ws-ease-out),
    box-shadow var(--ws-dur-fast) var(--ws-ease-out);
}
@media (hover: hover) and (pointer: fine) {
  .news-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 22px 50px -24px rgba(60, 36, 21, 0.36);
  }
}
.news-card:active {
  transform: translateY(-2px) scale(0.99);
}
.news-body {
  padding: 24px 24px 26px;
  display: flex;
  flex-direction: column;
  flex: 1;
  h3 {
    font-family: "Nunito", sans-serif;
    font-weight: 800;
    font-size: 19px;
    line-height: 1.28;
    color: #241b12;
    margin: 8px 0 12px;
  }
  p {
    font-size: 14.5px;
    line-height: 1.6;
    color: #6b5d52;
    flex: 1;
  }
}
.news-date {
  font-size: 13px;
  font-weight: 700;
  color: #a6907e;
}
.news-link {
  margin-top: 18px;
}

@media screen and (max-width: 900px) {
  .news-grid {
    grid-template-columns: 1fr;
  }
}
</style>
